// src/organization/index.ts
var ConnectOrganizationType = {
  Bank: "bank",
  SavingBank: "savingBank",
  Card: "card",
  Invest: "invest",
  Insurance: "insurance",
  GInsurance: "ginsurance",
  // 보증보험
  Capital: "capital",
  // 할부금융
  Telecom: "telecom",
  Efin: "efin"
  // 전자금융
};

// src/industry/index.ts
var Industry = {
  /** 은행 */
  BANK: "bank",
  /** 카드 */
  CARD: "card",
  /** 금융투자 */
  INVEST: "invest",
  /** 보험 */
  INSU: "insu",
  /** 전자금융 */
  EFIN: "efin",
  /** 할부금융 */
  CAPITAL: "capital",
  /** 보증보험 */
  GINSU: "ginsu",
  /** 통신 */
  TELECOM: "telecom"
};
function industryToConnectOrgType(industry, isSaving) {
  switch (industry) {
    case Industry.BANK:
      return isSaving ? ConnectOrganizationType.SavingBank : ConnectOrganizationType.Bank;
    case Industry.CARD:
      return ConnectOrganizationType.Card;
    case Industry.INVEST:
      return ConnectOrganizationType.Invest;
    case Industry.INSU:
      return ConnectOrganizationType.Insurance;
    case Industry.GINSU:
      return ConnectOrganizationType.GInsurance;
    case Industry.CAPITAL:
      return ConnectOrganizationType.Capital;
    case Industry.TELECOM:
      return ConnectOrganizationType.Telecom;
    case Industry.EFIN:
      return ConnectOrganizationType.Efin;
    default:
      throw new Error("\uC798\uBABB\uB41C \uD0C0\uC785");
  }
}

export { Industry, industryToConnectOrgType };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map